import { render, staticRenderFns } from "./KtTable.vue?vue&type=template&id=41238128&scoped=true"
import script from "./KtTable.vue?vue&type=script&lang=js"
export * from "./KtTable.vue?vue&type=script&lang=js"
import style0 from "./KtTable.vue?vue&type=style&index=0&id=41238128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41238128",
  null
  
)

export default component.exports